import { render } from "./SelectedOptions.vue?vue&type=template&id=46c7f9cc"
import script from "./SelectedOptions.vue?vue&type=script&lang=js"
export * from "./SelectedOptions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__